import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';
import Button from '../../components/ui/Button';
import MainNavigation from '../../components/ui/MainNavigation';
import FooterSection from '../homepage/components/FooterSection';

import ComparisonModal from '../../components/ComparisonModal';
import { useState } from 'react';
import { AnimatePresence } from 'framer-motion';

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';


const InsulationCategoryPage = () => {
  const [comparisonProducts, setComparisonProducts] = useState([]);
  const [isComparisonOpen, setIsComparisonOpen] = useState(false);

  const handleAddToCompare = (product) => {
    setComparisonProducts((prev) => {
      const exists = prev?.find(p => p?.id === product?.id);
      if (exists) {
        return prev;
      }
      if (prev?.length >= 3) {
        return [...prev?.slice(1), product];
      }
      return [...prev, product];
    });
  };

  const featuredBrandData = {
    brandName: "Rockwool",
    brandLogo: "https://ui-avatars.com/api/?name=Rockwool&background=8b5cf6&color=fff&size=80",
    brandDescription: "Wereldleider in steenwol isolatie",
    productName: "Rockwool Spijkerflensdeken",
    productImage: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&h=600&fit=crop",
    productImageAlt: "Rockwool steenwol isolatie wordt geïnstalleerd tussen dakspanten voor optimale warmte-isolatie",
    productDescription: "Premium steenwol dakisolatie met uitstekende thermische en akoestische eigenschappen. Brandwerend en duurzaam.",
    productSpecs: [
      { icon: "Thermometer", label: "Rc-waarde", value: "6.0 m²K/W" },
      { icon: "Layers", label: "Dikte", value: "200 mm" },
      { icon: "Flame", label: "Brandklasse", value: "A1" },
      { icon: "Shield", label: "Garantie", value: "50 jaar" }
    ],
    productPrice: "€3.500",
    rating: 4.8,
    reviewCount: 392,
    reviews: [
      {
        rating: 5,
        text: "Ons huis is nu veel warmer in de winter en koeler in de zomer. Energierekening met 35% gedaald!",
        name: "Karin Mulder",
        location: "Almere",
        avatar: "https://ui-avatars.com/api/?name=Karin+M&background=8b5cf6&color=fff",
        verified: true
      },
      {
        rating: 5,
        text: "Professionele installatie en topkwaliteit materiaal. Het verschil is direct merkbaar. Aanrader!",
        name: "Henk Dijkstra",
        location: "Enschede",
        avatar: "https://ui-avatars.com/api/?name=Henk+D&background=7c3aed&color=fff",
        verified: true
      },
      {
        rating: 4,
        text: "Uitstekende isolatie met goede brandwerende eigenschappen. Ook veel stiller in huis nu.",
        name: "Marieke Bos",
        location: "Breda",
        avatar: "https://ui-avatars.com/api/?name=Marieke+B&background=6d28d9&color=fff",
        verified: true
      }
    ],
    colorScheme: "from-purple-500/10 to-pink-500/10",
    accentColor: "text-purple-600",
    bgGradient: "from-purple-50 via-pink-50 to-blue-50"
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const insulationTypes = [
    {
      id: 1,
      name: "Dakisolatie",
      description: "De meest effectieve isolatiemaatregel. Via het dak gaat 30-40% van de warmte verloren.",
      suitability: "Geschikt voor alle woningtypes met toegankelijke dakruimte",
      attention: "Combineer met goede ventilatie om vochtproblemen te voorkomen",
      savings: "30-40%",
      image: "https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?w=400&h=300&fit=crop",
      alt: "Professionele installatie van dakisolatie tussen dakspanten in zolder",
      icon: "Home",
      color: "from-purple-500/10 to-pink-500/10"
    },
    {
      id: 2,
      name: "Spouwmuurisolatie",
      description: "Snel en effectief te plaatsen in bestaande spouwmuren zonder grote verbouwing.",
      suitability: "Geschikt voor woningen gebouwd tussen 1920-1980 met spouwmuur",
      attention: "Laat eerst spouw inspecteren op vochtproblemen en vervuiling",
      savings: "20-25%",
      image: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=400&h=300&fit=crop",
      alt: "Spouwmuurisolatie wordt geïnjecteerd in gevel van woning",
      icon: "Layers",
      color: "from-blue-500/10 to-cyan-500/10"
    },
    {
      id: 3,
      name: "Gevelisolatie",
      description: "Isolatie aan de buitenzijde van de gevel, ideaal bij renovatie of nieuwbouw.",
      suitability: "Geschikt voor woningen zonder spouwmuur of bij grootschalige renovatie",
      attention: "Vergunning vaak nodig, verandert uiterlijk van de woning",
      savings: "25-30%",
      image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop",
      alt: "Buitengevelisolatie wordt aangebracht op woning met isolatieplaten",
      icon: "Square",
      color: "from-green-500/10 to-emerald-500/10"
    },
    {
      id: 4,
      name: "Vloerisolatie",
      description: "Voorkomt koude voeten en warmteverlies via de begane grond.",
      suitability: "Geschikt voor woningen met kruipruimte of toegankelijke ondervloer",
      attention: "Combineer met goede kruipruimteventilatie",
      savings: "10-15%",
      image: "https://images.unsplash.com/photo-1615971677499-5467cbab01c0?w=400&h=300&fit=crop",
      alt: "Vloerisolatie wordt geïnstalleerd in kruipruimte onder begane grond",
      icon: "Minus",
      color: "from-orange-500/10 to-red-500/10"
    }
  ];

  const heatLossData = [
    { area: 'Dak', percentage: 35, color: '#8b5cf6' },
    { area: 'Gevel', percentage: 25, color: '#3b82f6' },
    { area: 'Ramen', percentage: 20, color: '#10b981' },
    { area: 'Vloer', percentage: 15, color: '#f59e0b' },
    { area: 'Ventilatie', percentage: 5, color: '#ef4444' }
  ];

  const costData = [
    { type: 'Dakisolatie', min: 2500, max: 5000, avg: 3750 },
    { type: 'Spouwmuur', min: 1500, max: 2500, avg: 2000 },
    { type: 'Gevelisolatie', min: 8000, max: 15000, avg: 11500 },
    { type: 'Vloerisolatie', min: 2000, max: 4000, avg: 3000 }
  ];

  const commonMistakes = [
    {
      id: 1,
      mistake: "Isoleren zonder ventilatie",
      correct: "Goede ventilatie is essentieel om vochtproblemen en schimmel te voorkomen",
      icon: "Wind",
      color: "text-error"
    },
    {
      id: 2,
      mistake: "Verkeerde volgorde van maatregelen",
      correct: "Begin met isolatie voordat je een warmtepomp installeert voor optimaal rendement",
      icon: "ListOrdered",
      color: "text-warning"
    },
    {
      id: 3,
      mistake: "Alleen op prijs selecteren",
      correct: "Kwaliteit materiaal en vakmanschap bepalen de levensduur en effectiviteit",
      icon: "DollarSign",
      color: "text-warning"
    },
    {
      id: 4,
      mistake: "Koudebruggen negeren",
      correct: "Let op aansluitingen en overgangen waar warmte kan ontsnappen",
      icon: "AlertTriangle",
      color: "text-error"
    }
  ];

  const providers = [
    {
      id: 1,
      name: "IsolatieXpert",
      rating: 4.9,
      reviews: 456,
      specialization: "Dak- en spouwmuurisolatie",
      region: "Landelijk",
      image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=100&h=100&fit=crop",
      alt: "IsolatieXpert bedrijfspand met moderne isolatiematerialen"
    },
    {
      id: 2,
      name: "Warmte & Comfort",
      rating: 4.7,
      reviews: 328,
      specialization: "Complete isolatieoplossingen",
      region: "Randstad",
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=100&h=100&fit=crop",
      alt: "Warmte & Comfort kantoor met energiezuinige installaties"
    },
    {
      id: 3,
      name: "EcoTherm Isolatie",
      rating: 4.8,
      reviews: 392,
      specialization: "Duurzame isolatiematerialen",
      region: "Landelijk",
      image: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=100&h=100&fit=crop",
      alt: "EcoTherm Isolatie team bij isolatieproject"
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <MainNavigation />
      {/* Main Content with proper spacing for fixed navigation */}
      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
      {/* Hero Section */}
      <motion.section 
        className="relative bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 overflow-hidden py-16 lg:py-24"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <div className="absolute inset-0 opacity-30">
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <motion.div variants={itemVariants}>
              <div className="inline-flex items-center space-x-2 bg-purple-100 px-4 py-2 rounded-full mb-6">
                <Icon name="Home" size={20} className="text-purple-600" />
                <span className="text-sm font-medium text-purple-800">Isolatie</span>
              </div>
              <h1 className="text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
                Isolatie: de slimste eerste stap in verduurzamen
              </h1>
              <p className="text-lg text-muted-foreground mb-6">
                De basis van elke duurzame woning: minder warmteverlies, meer comfort en lagere energiekosten. Goede isolatie verlaagt uw energieverbruik direct, verhoogt het wooncomfort en maakt andere verduurzamingsmaatregelen effectiever.
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/quote-request-form">
                  <Button size="lg" iconName="FileText" iconPosition="left">
                    Offerte aanvragen
                  </Button>
                </Link>
                <Button variant="outline" size="lg" iconName="Calculator" iconPosition="left">
                  Bereken besparing
                </Button>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-elevation-3">
                <Image
                  src="https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?w=800&h=600&fit=crop"
                  alt="Doorsnede van woning met gemarkeerde dak-, gevel- en vloerisolatie met warmtestromen"
                  className="w-full h-auto"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="bg-white/95 backdrop-blur-sm rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-muted-foreground">Besparing</p>
                        <p className="text-2xl font-bold text-success">30-40%</p>
                      </div>
                      <div className="text-right">
                        <p className="text-sm text-muted-foreground">Comfort</p>
                        <p className="text-2xl font-bold text-primary">+3°C</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>
      {/* Why Insulation is Crucial */}
      <motion.section 
        className="py-16 lg:py-20 bg-white"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div variants={itemVariants} className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
              Waarom isolatie cruciaal is
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Investeren in isolatie levert directe en langdurige voordelen op
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-2 gap-8 mb-12">
            <motion.div variants={itemVariants}>
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 lg:p-8 border border-purple-100 h-full">
                <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
                  Warmteverlies per onderdeel
                </h3>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={heatLossData}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      label={({ area, percentage }) => `${area} ${percentage}%`}
                      outerRadius={100}
                      fill="#8884d8"
                      dataKey="percentage"
                    >
                      {heatLossData?.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry?.color} />
                      ))}
                    </Pie>
                    <Tooltip formatter={(value) => `${value}%`} />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="space-y-6">
              <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 border border-green-100">
                <div className="w-12 h-12 bg-success rounded-lg flex items-center justify-center mb-4">
                  <Icon name="TrendingDown" size={24} className="text-white" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Tot 30-40% warmteverlies via dak en gevel
                </h3>
                <p className="text-muted-foreground">
                  Zonder goede isolatie verdwijnt het grootste deel van uw verwarmingsenergie via dak en gevels. Dit betekent hogere stookkosten en minder comfort.
                </p>
              </div>

              <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-100">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mb-4">
                  <Icon name="Euro" size={24} className="text-white" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Direct lagere energierekening
                </h3>
                <p className="text-muted-foreground">
                  Goede isolatie verlaagt uw energieverbruik direct met 30-40%. Bij gemiddeld verbruik bespaart u €400-€800 per jaar.
                </p>
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6 border border-orange-100">
                <div className="w-12 h-12 bg-warning rounded-lg flex items-center justify-center mb-4">
                  <Icon name="Home" size={24} className="text-white" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-foreground mb-3">
                  Stillere woning en stabielere temperatuur
                </h3>
                <p className="text-muted-foreground">
                  Isolatie dempt ook geluid van buiten en zorgt voor een constante binnentemperatuur zonder grote schommelingen.
                </p>
              </div>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="grid md:grid-cols-2 gap-6">
            <div className="relative rounded-xl overflow-hidden">
              <Image
                src="https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=600&h=400&fit=crop"
                alt="Thermografische foto van slecht geïsoleerde woning toont warmteverlies in rood en oranje"
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
                <div className="p-6">
                  <h4 className="text-lg font-heading font-semibold text-white mb-2">
                    Thermografische foto: warmteverlies
                  </h4>
                  <p className="text-white/90 text-sm">
                    Rode en oranje zones tonen waar warmte ontsnapt
                  </p>
                </div>
              </div>
            </div>

            <div className="relative rounded-xl overflow-hidden">
              <Image
                src="https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?w=600&h=400&fit=crop"
                alt="Detailfoto van hoogwaardig isolatiemateriaal in spouwmuur installatie"
                className="w-full h-64 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end">
                <div className="p-6">
                  <h4 className="text-lg font-heading font-semibold text-white mb-2">
                    Hoogwaardig isolatiemateriaal
                  </h4>
                  <p className="text-white/90 text-sm">
                    Moderne materialen met lange levensduur
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.section>
      {/* Types of Insulation */}
      <motion.section 
        className="py-16 lg:py-20 bg-background"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div variants={itemVariants} className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
              Soorten isolatie
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Kies de isolatiemaatregel die het beste bij uw woning past
            </p>
          </motion.div>

          <div className="space-y-8">
            {insulationTypes?.map((type, index) => (
              <motion.div
                key={type?.id}
                variants={itemVariants}
                className="bg-white rounded-xl shadow-elevation-2 overflow-hidden hover:shadow-elevation-3 transition-shadow"
              >
                <div className={`grid md:grid-cols-2 gap-6 ${index % 2 === 1 ? 'md:grid-flow-dense' : ''}`}>
                  <div className={`relative ${index % 2 === 1 ? 'md:col-start-2' : ''}`}>
                    <Image
                      src={type?.image}
                      alt={type?.alt}
                      className="w-full h-full object-cover min-h-[300px]"
                    />
                    <div className={`absolute inset-0 bg-gradient-to-br ${type?.color} opacity-20`}></div>
                    <div className="absolute top-4 right-4 bg-white rounded-full p-3 shadow-elevation-2">
                      <Icon name={type?.icon} size={24} className="text-primary" />
                    </div>
                    <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm rounded-lg px-4 py-2">
                      <p className="text-sm text-muted-foreground">Besparing</p>
                      <p className="text-xl font-bold text-success">{type?.savings}</p>
                    </div>
                  </div>

                  <div className="p-6 lg:p-8 flex flex-col justify-center">
                    <h3 className="text-2xl font-heading font-bold text-foreground mb-3">
                      {type?.name}
                    </h3>
                    <p className="text-muted-foreground mb-4">
                      {type?.description}
                    </p>

                    <div className="space-y-3">
                      <div className="flex items-start space-x-3">
                        <div className="w-6 h-6 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <Icon name="CheckCircle" size={16} className="text-success" />
                        </div>
                        <div>
                          <p className="font-medium text-foreground">Wanneer geschikt</p>
                          <p className="text-sm text-muted-foreground">{type?.suitability}</p>
                        </div>
                      </div>

                      <div className="flex items-start space-x-3">
                        <div className="w-6 h-6 bg-warning/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                          <Icon name="AlertCircle" size={16} className="text-warning" />
                        </div>
                        <div>
                          <p className="font-medium text-foreground">Aandachtspunten</p>
                          <p className="text-sm text-muted-foreground">{type?.attention}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
      {/* Costs, ROI & Subsidies */}
      <motion.section 
        className="py-16 lg:py-20 bg-white"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div variants={itemVariants} className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
              Kosten, rendement & subsidies
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Inzicht in de investering en terugverdientijd
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 lg:p-8 border border-blue-100 mb-12">
            <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
              Indicatieve kosten per isolatietype
            </h3>
            <ResponsiveContainer width="100%" height={350}>
              <BarChart data={costData} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                <XAxis type="number" tick={{ fontSize: 12 }} />
                <YAxis dataKey="type" type="category" width={120} tick={{ fontSize: 12 }} />
                <Tooltip 
                  contentStyle={{ backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                  formatter={(value) => `€${value?.toLocaleString('nl-NL')}`}
                />
                <Bar dataKey="min" fill="#93c5fd" name="Minimum" radius={[0, 4, 4, 0]} />
                <Bar dataKey="avg" fill="#3b82f6" name="Gemiddeld" radius={[0, 4, 4, 0]} />
                <Bar dataKey="max" fill="#1e40af" name="Maximum" radius={[0, 4, 4, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </motion.div>

          <motion.div variants={itemVariants} className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-card border border-border rounded-xl p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="Clock" size={20} className="text-primary" />
                </div>
                <h4 className="font-heading font-semibold text-foreground">Terugverdientijd</h4>
              </div>
              <p className="text-3xl font-bold text-foreground mb-2">5-10 jaar</p>
              <p className="text-sm text-muted-foreground">Afhankelijk van type isolatie</p>
            </div>

            <div className="bg-card border border-border rounded-xl p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                  <Icon name="TrendingDown" size={20} className="text-success" />
                </div>
                <h4 className="font-heading font-semibold text-foreground">Besparing per jaar</h4>
              </div>
              <p className="text-3xl font-bold text-foreground mb-2">€400-€800</p>
              <p className="text-sm text-muted-foreground">Bij gemiddeld verbruik</p>
            </div>

            <div className="bg-card border border-border rounded-xl p-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
                  <Icon name="Gift" size={20} className="text-warning" />
                </div>
                <h4 className="font-heading font-semibold text-foreground">Subsidie</h4>
              </div>
              <p className="text-3xl font-bold text-foreground mb-2">Tot €4.000</p>
              <p className="text-sm text-muted-foreground">ISDE en lokale regelingen</p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-blue-50 border border-blue-200 rounded-xl p-6">
            <div className="flex items-start space-x-3">
              <Icon name="Info" size={24} className="text-primary flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-heading font-semibold text-foreground mb-2">Subsidies & regelingen</h4>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li className="flex items-start space-x-2">
                    <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0 mt-0.5" />
                    <span><strong>ISDE subsidie:</strong> Tot €4.000 voor isolatiemaatregelen in combinatie met andere verduurzaming</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0 mt-0.5" />
                    <span><strong>Lokale subsidies:</strong> Veel gemeenten bieden extra financiële ondersteuning voor isolatie</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0 mt-0.5" />
                    <span><strong>BTW-verlaging:</strong> Voor bepaalde isolatiewerkzaamheden geldt verlaagd BTW-tarief van 9%</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0 mt-0.5" />
                    <span><strong>Energiebespaarlening:</strong> Voordelige lening via het Nationaal Warmtefonds</span>
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.section>
      {/* Common Mistakes */}
      <motion.section 
        className="py-16 lg:py-20 bg-background"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div variants={itemVariants} className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
              Veelgemaakte fouten
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Vermijd deze valkuilen bij isolatiewerkzaamheden
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-6">
            {commonMistakes?.map((item) => (
              <motion.div
                key={item?.id}
                variants={itemVariants}
                className="bg-white rounded-xl p-6 border-l-4 border-error shadow-elevation-1 hover:shadow-elevation-2 transition-shadow"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-error/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name={item?.icon} size={24} className={item?.color} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-start justify-between mb-3">
                      <div>
                        <div className="inline-flex items-center space-x-2 bg-error/10 px-3 py-1 rounded-full mb-2">
                          <Icon name="X" size={14} className="text-error" />
                          <span className="text-xs font-medium text-error">Fout</span>
                        </div>
                        <h3 className="text-lg font-heading font-semibold text-foreground">
                          {item?.mistake}
                        </h3>
                      </div>
                    </div>
                    <div className="bg-success/5 border border-success/20 rounded-lg p-4">
                      <div className="flex items-start space-x-2">
                        <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0 mt-0.5" />
                        <div>
                          <p className="text-xs font-medium text-success mb-1">Juiste aanpak</p>
                          <p className="text-sm text-foreground">{item?.correct}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div variants={itemVariants} className="mt-8 relative rounded-xl overflow-hidden">
            <Image
              src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1200&h=400&fit=crop"
              alt="Professionele isolatie-installatie met correcte ventilatie en koudebruggen behandeling"
              className="w-full h-64 object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent flex items-center">
              <div className="px-8 max-w-2xl">
                <h3 className="text-2xl font-heading font-bold text-white mb-2">
                  Vakmanschap maakt het verschil
                </h3>
                <p className="text-white/90 mb-4">
                  Laat isolatiewerkzaamheden uitvoeren door gecertificeerde professionals die aandacht hebben voor details en ventilatie.
                </p>
                <Button variant="outline" size="lg" iconName="Users" iconPosition="left" className="bg-white text-foreground hover:bg-white/90">
                  Vind specialisten
                </Button>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.section>
      {/* Providers & Reviews */}
      <motion.section 
        className="py-16 lg:py-20 bg-white"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div variants={itemVariants} className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
              Aanbieders & ervaringen
            </h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Geselecteerde isolatiebedrijven met bewezen kwaliteit
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6 mb-8">
            {providers?.map((provider) => (
              <motion.div
                key={provider?.id}
                variants={itemVariants}
                whileHover={{ y: -8, transition: { duration: 0.3 } }}
                className="bg-card border border-border rounded-xl overflow-hidden shadow-elevation-1 hover:shadow-elevation-3 transition-all"
              >
                <div className="relative h-32 bg-gradient-to-br from-purple-100 to-pink-100">
                  <Image
                    src={provider?.image}
                    alt={provider?.alt}
                    className="w-full h-full object-cover opacity-60"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
                    {provider?.name}
                  </h3>
                  <div className="flex items-center space-x-2 mb-3">
                    <div className="flex items-center">
                      {[...Array(5)]?.map((_, i) => (
                        <Icon 
                          key={i} 
                          name="Star" 
                          size={14} 
                          className={`${i < Math.floor(provider?.rating) ? 'text-yellow-500 fill-current' : 'text-gray-300'}`} 
                        />
                      ))}
                    </div>
                    <span className="text-sm font-medium text-foreground">{provider?.rating}</span>
                    <span className="text-sm text-muted-foreground">({provider?.reviews} reviews)</span>
                  </div>
                  <div className="space-y-2 mb-4">
                    <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                      <Icon name="Wrench" size={14} className="text-primary" />
                      <span>{provider?.specialization}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                      <Icon name="MapPin" size={14} className="text-primary" />
                      <span>{provider?.region}</span>
                    </div>
                  </div>
                  <Link to="/leveranciers">
                    <Button variant="outline" size="sm" iconName="ExternalLink" iconPosition="right" fullWidth>
                      Bekijk profiel
                    </Button>
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div variants={itemVariants} className="text-center">
            <Link to="/quote-request-form">
              <Button size="lg" iconName="FileText" iconPosition="left">
                Ontvang offertes van meerdere specialisten
              </Button>
            </Link>
          </motion.div>
        </div>
      </motion.section>
      <FooterSection />
      </main>
      <FooterSection />
      {/* Floating Compare Button */}
      <AnimatePresence>
        {comparisonProducts?.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            className="fixed bottom-6 right-6 z-40"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setIsComparisonOpen(true)}
              className="bg-primary text-white px-6 py-4 rounded-full shadow-2xl flex items-center space-x-3 hover:bg-primary/90 transition-colors"
            >
              <Icon name="GitCompare" size={24} />
              <span className="font-semibold">Vergelijk ({comparisonProducts?.length})</span>
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
      {/* Comparison Modal */}
      <ComparisonModal
        isOpen={isComparisonOpen}
        onClose={() => setIsComparisonOpen(false)}
        products={comparisonProducts}
        category="isolatie"
      />
    </div>
  );
};

export default InsulationCategoryPage;